import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IoIosArrowDropdown } from "react-icons/io";
import { IoPricetagOutline } from "react-icons/io5";
import { SlBookOpen } from "react-icons/sl";
import { CiCircleChevLeft } from "react-icons/ci";
import { CiCircleChevRight } from "react-icons/ci";
import { ImSpinner2 } from "react-icons/im";
import { IoIosRefresh } from "react-icons/io";
import Loader from '../../components/ui/loader'
import { FaRegFilePdf } from "react-icons/fa6";
import {Link} from "react-router-dom";
import { LeftOutlined, RightOutlined, StopOutlined } from "@ant-design/icons";

import {
  Button,
  Typography,
  Modal,
  Table,
  Pagination,
  List,
  Card,
  Tag,
  Collapse,
  Avatar,
  Divider,
  Form,
  Input,
  Select,
  Upload,
  Row,
  Col,
  Tabs,
  Space,
  Breadcrumb,
  Alert,
  Empty,
  Tooltip,
  DatePickerProps,
  DatePicker
} from "antd";
import axios from "axios";
import {
  DeleteOutlined,
  FileTextOutlined,
  VideoCameraOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  UploadOutlined,
  BookOutlined,
  UserOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  BarsOutlined,

  CheckCircleFilled,

  FileOutlined,

} from "@ant-design/icons";
import Footer from "../../components/navigation/footer";
import { BookOpen } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;


const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
}

const sortFunctions = {
  enrollment_id: (a, b) => a.enrollment_id - b.enrollment_id,
  user_id: (a, b) => a.user_id - b.user_id,
  first_name: (a, b) => a.first_name.localeCompare(b.first_name),
  last_name: (a, b) => a.last_name.localeCompare(b.last_name),
  email: (a, b) => a.email.localeCompare(b.email),
  phone_number: (a, b) => a.phone_number?.localeCompare(b.phone_number || ''),
  enrollment_date: (a, b) => new Date(a.enrollment_date) - new Date(b.enrollment_date),
};


export const ViewCourseDetails = () => {
  const { courseId, cloudId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [completedModules, setCompletedModules] = useState([]);
  const [completedLessons, setCompletedLessons] = useState([]);
  const [exams, setExams] = useState([]);
  const [examQuestions, setExamQuestions] = useState([]);
  const [message, setMessage] = useState({ text: "", type: "", visible: false });
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedCloudId, setSelectedCloudId] = useState(null)
  const [enrolledUsers, setEnrolledUsers] = useState([]);
  const [enrolledLoading, setEnrolledLoading] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterModalVisible, setFilterModalVisible] = useState(false);

  // Editing state
  const [editMode, setEditMode] = useState(false);
  const [editedCourse, setEditedCourse] = useState(null);
  const [editingModule, setEditingModule] = useState(null);
  const [editingLesson, setEditingLesson] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [newVideo, setNewVideo] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();
  const videoRef = useRef(null);

  // Video playback state
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isPDF, setIsPDF] = useState(false);
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [isResourceModalVisible, setIsResourceModalVisible] = useState(false);
  const [isError404, setIsError404] = useState(false);
  const [showEnrolledModal, setShowEnrolledModal] = useState(false);
  const [search, setSearch] = useState("");
  const [searchDebounce, setSearchDebounce] = useState(search)
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const limit = 10;
  const isMobile = useIsMobile();
  const [publishing, setPublishing] = useState(false);

  const [userSortField, setUserSortField] = useState('user_id');
  const [userSortOrder, setUserSortOrder] = useState('asc');

  const sortedUsers = [...enrolledUsers].sort((a, b) => {
    const result = sortFunctions[userSortField](a, b);
    return userSortOrder === 'asc' ? result : -result;
  });



  const handleUserSortFieldChange = (value) => setUserSortField(value);
  const handleUserSortOrderChange = (value) => setUserSortOrder(value);


  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const baseURL = `${API_URL}`

  const paginateUsers = (page) => {
    setPage(page);
  }




  //fetch course details
  const fetchCourseDetails = async (courseId) => {
    const res = await fetch(`${baseURL}/admin/view-course/${courseId}`, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      credentials: "include",
    });
    if (res.status === 404) {
      setIsError404(true);
      throw new Error("This course has been removed")
    }

    if (!res.ok) throw new Error("Failed to fetch course details");
    const json = await res.json();

    const { course, modules, learningOutcomes, exam, examWithQuestions, progress } = json;

    // Normalize lesson video URLs
    for (const module of modules) {
      for (const lesson of module.lessons || []) {
        if (typeof lesson.content === 'string') {
          if (lesson.content.startsWith('/uploads/')) {
            lesson.videoUrl = `${baseURL}${lesson.content}`;
          } else if (!lesson.content.includes('://')) {
            lesson.videoUrl = `${baseURL}/uploads/${lesson.content}`;
          } else {
            lesson.videoUrl = lesson.content;
          }
        }
      }
    }

    course.modules = modules;
    course.learningOutcomes = Object.values(learningOutcomes);

    return {
      course,
      exam: exam ? [exam] : [],
      examWithQuestions,
      progress
    };
  };


  const {
    data,
    isLoading: courseLoading,

    refetch: courseRefetch,
  } = useQuery({
    queryKey: ['courseDetails', courseId],
    queryFn: () => fetchCourseDetails(courseId),
    enabled: !!courseId && !isNaN(Number(courseId)), // prevent auto-run if courseId is invalid
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  useEffect(() => {

    if (data) {
      const { course, exam, examWithQuestions, progress } = data;

      setCourse(course);
      setExams(exam);
      setExamQuestions(examWithQuestions);
      setEditedCourse(JSON.parse(JSON.stringify(course)));
      setCompletedModules(progress?.completedModules || []);
      setCompletedLessons(progress?.completedLessons || []);

    }
  }, [data]);

  //export enrollments
  const exportEnrollments = async () => {
    try {
      setIsExportLoading(true);

      const params = new URLSearchParams();

      if (startDate) {
        params.append("startDate", startDate);
      }

      if (endDate) {
        params.append("endDate", endDate);
      }

      const res = await fetch(
        `${baseURL}/admin/export-enrollments/${courseId}?${params}`,
        {
          credentials: "include",
        }
      );

      if (!res.ok) throw new Error("Failed to export enrollments");

      const blob = await res.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.href = url;
      a.download = `enrollments-${courseId}.csv`;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setFilterModalVisible(false);

      setMessage({
        text: "Enrollments exported successfully",
        type: "success",
        visible: true
      });

    } catch (error) {
      setFilterModalVisible(false);


      setMessage({
        text: "Failed to export enrollments",
        type: "error",
        visible: true
      });

    } finally {

      setIsExportLoading(false);

      setTimeout(() =>
        setMessage(prev => ({ ...prev, visible: false }))
        , 5000);

    }
  };

  //fetch users enrolled in course currently being viewed. RENDERED IN TABLE IN MODAL
  const fetchEnrolledUsers = async ({ queryKey }) => {
    const [_key, { courseId, search, page, limit }] = queryKey;
    const params = new URLSearchParams({
      search: search || "",
      page: page?.toString() || "1",
      limit: limit?.toString() || "15",
    });

    const res = await fetch(`${baseURL}/admin/enrollments/${courseId}?${params}`, {
      credentials: "include", //cookies
    });

    if (!res.ok) throw new Error("Failed to fetch enrolled users");

    return res.json();

  }

  const {
    data: enrolledData,
    isLoading: isEnrolledDataLoading,
    isError,
    error,
    refetch: enrolledRefetch,
  } = useQuery({
    queryKey: ["enrolledUsers", { courseId, search: searchDebounce, page, limit }],
    queryFn: fetchEnrolledUsers,
    keepPreviousData: true, // smooth pagination
    staleTime: 1000 * 30,   // 30 seconds cache
    enabled: !!courseId && showEnrolledModal,

  });

  useEffect(() => {
    if (enrolledData) {
      setEnrolledUsers(enrolledData.enrolledUsers)
      setTotalPages(enrolledData.totalPages);
    }


  }, [enrolledData])

  // search debounce
  useEffect(() => {
    const handler = setTimeout(() => setSearchDebounce(search), 500);
    return () => clearTimeout(handler);
  }, [search]);


  const handleVideoPlay = (video) => {
    setSelectedVideo(video);
    setIsVideoModalVisible(true);
  };

  const handleEnrollModalClose = () => {
    setShowEnrolledModal(false);
  }

  // Function to close video modal
  const handleVideoClose = () => {
    setIsVideoModalVisible(false);
    setSelectedVideo(null);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const handleResourcePreview = (resource) => {
    setSelectedResource(resource);
    setIsResourceModalVisible(true);
  };

  const handleResourceClose = () => {
    setIsResourceModalVisible(false);
    setSelectedResource(null);
  };

  const calculateCompletionPercentage = () => {
    if (!course || !course.modules) return 0;

    const totalLessons = course.modules.reduce(
      (sum, module) => sum + (module.lessons?.length || 0),
      0
    );

    if (totalLessons === 0) return 0;
    return Math.round((completedLessons.length / totalLessons) * 100);
  };

  const isModuleCompleted = (moduleId) => {
    return completedModules.includes(moduleId);
  };

  const isLessonCompleted = (lessonId) => {
    return completedLessons.includes(lessonId);
  };

  const confirmPublish = async () => {
    try {
      const published = course.published === true ? 1 : 0; // Toggle published state
      setPublishing(true)
      setShowPublishModal(false)

      const response = await fetch(`${API_URL}/admin/publish-course/${selectedCourseId}/${selectedCloudId}/${published}`, {
        method: 'PATCH',
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        setPublishing(false)
        setMessage({ text: data.message || "Error publishing course. Something went wrong", type: "error", visible: "true" })

        throw data; // Will be caught below
      }

      courseRefetch(); // Refresh course data after publishing
      setPublishing(false)

      setMessage({ text: data.message || "Course published successfully", type: "success", visible: "true" })

    } catch (error) {
      setPublishing(false);

      setMessage({ text: "Failed to update course publish status.", type: "error", visible: "true" })
      console.error('Error publishing course:', error);

    } finally {
      setPublishing(false);
      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

    }

  };

  const handlePublishToggle = async (courseId, cloudId) => {
    setSelectedCourseId(courseId);
    setSelectedCloudId(cloudId);
    setShowPublishModal(true);
  };

  const handleViewLesson = (lesson) => {

    let fileUrl = lesson.videoUrl || lesson.lesson_video || lesson.content;

    if (typeof fileUrl === 'string') {
      if (fileUrl.startsWith('/uploads/')) {
        fileUrl = `${API_URL}${fileUrl}`;
      } else if (fileUrl.startsWith('/') || fileUrl.startsWith('./')) {
        const filename = fileUrl.split('/').pop();
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${filename}`;
      } else if (!fileUrl.startsWith('http')) {
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${fileUrl}`;
      }
    } else if (fileUrl && typeof fileUrl === 'object') {
      if (fileUrl.url) {
        fileUrl = fileUrl.url.startsWith('/')
          ? `${API_URL}${fileUrl.url}`
          : fileUrl.url;
      } else if (fileUrl.path) {
        const filename = fileUrl.path.split(/[\\/]/).pop();
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${filename}`;
      } else if (fileUrl.name) {
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${fileUrl.name}`;
      } else if (fileUrl.originalname) {
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${fileUrl.originalname}`;
      } else if (fileUrl.filename) {
        fileUrl = `${API_URL}/uploads/course_videos_pdfs/${fileUrl.filename}`;
      }
    }

    if (fileUrl) {
      const isPDF = fileUrl.toLowerCase().endsWith('.pdf');

      setSelectedVideo(fileUrl);
      setIsPDF(isPDF); // NEW: track if it’s a PDF
      setIsVideoModalVisible(true);
    } else {
      message.info('No video or document available for this lesson.');
    }
  };

  // Editing functionality
  const toggleEditMode = () => {
    if (editMode) {
      // If exiting edit mode without saving
      setEditedCourse(JSON.parse(JSON.stringify(course))); // Reset to original
      setEditingModule(null);
      setEditingLesson(null);
      setNewImage(null);
      setPreviewImage(null);
      setNewVideo(null);
      setPreviewVideo(null);
    }
    setEditMode(!editMode);
  };

  const handleImageChange = (info) => {
    const file = info.file.originFileObj || info.file;
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setMessage({ text: "Image must be smaller than 5MB", type: "error", visible: true });
        setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);
        return false;
      }
      setNewImage(file);
      const reader = new FileReader();
      reader.onload = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
    return false;
  };

  const handleVideoChange = (info, moduleIndex, lessonIndex) => {
    const file = info.file.originFileObj || info.file;
    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setMessage({ text: "Video must be smaller than 100MB", type: "error", visible: true });
        setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000); return false;
      }

      setNewVideo({
        file,
        moduleIndex,
        lessonIndex
      });

      // Create a preview URL
      const videoURL = URL.createObjectURL(file);
      setPreviewVideo({
        url: videoURL,
        moduleIndex,
        lessonIndex
      });

      // Get video duration
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        const durationInMinutes = Math.round(video.duration / 60); // Convert to minutes

        // Update lesson duration
        updateLessonField(moduleIndex, lessonIndex, 'lesson_duration', durationInMinutes);
      };
      video.src = videoURL;
    }
    return false;
  };

  const updateCourseField = (field, value) => {
    setEditedCourse({
      ...editedCourse,
      [field]: value
    });
  };

  const updateModuleField = (moduleIndex, field, value) => {
    const updatedModules = [...editedCourse.modules];
    updatedModules[moduleIndex] = {
      ...updatedModules[moduleIndex],
      [field]: value
    };
    setEditedCourse({
      ...editedCourse,
      modules: updatedModules
    });
  };

  const updateLessonField = (moduleIndex, lessonIndex, field, value) => {
    const updatedModules = [...editedCourse.modules];
    if (updatedModules[moduleIndex].lessons) {
      updatedModules[moduleIndex].lessons[lessonIndex] = {
        ...updatedModules[moduleIndex].lessons[lessonIndex],
        [field]: value
      };
      setEditedCourse({
        ...editedCourse,
        modules: updatedModules
      });
    }
  };

  const handleSaveChanges = async () => {
    try {
      // Validate required fields before submitting
      if (!editedCourse.title?.trim()) {
        setMessage({ text: "Course Title is required", type: "error", visible: true });
        setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000); return;
      }

      if (!editedCourse.description?.trim()) {
        setMessage({ text: "Course description is required", type: "error", visible: true });
        return;
      }

      if (!editedCourse.category?.trim()) {
        setMessage({ text: "Course category is required", type: "error", visible: true });
        return;
      }

      if (!editedCourse.difficulty) {
        setMessage({ text: "Course difficulty is required", type: "error", visible: true });
        return;
      }

      // Validate modules
      if (!editedCourse.modules || editedCourse.modules.length === 0) {
        setMessage({ text: "At least one module is required", type: "error", visible: true });
        return;
      }

      // Check if any module has empty name
      const emptyModuleNames = editedCourse.modules.filter(module => !module.module_name?.trim());
      if (emptyModuleNames.length > 0) {
        setMessage({ text: "All modules must have a title", type: "error", visible: true });
        return;
      }

      // Check if any lesson has empty title
      let hasEmptyLessonTitles = false;
      editedCourse.modules.forEach(module => {
        if (module.lessons) {
          module.lessons.forEach(lesson => {
            if (!lesson.title?.trim()) {
              hasEmptyLessonTitles = true;
            }
          });
        }
      });

      if (hasEmptyLessonTitles) {
        setMessage({ text: "All lessons must have a title", type: "error", visible: true });
        return;
      }

      setUploading(true);

      // Create a FormData object for file uploads
      const formData = new FormData();

      // Add basic course info
      formData.append("title", editedCourse.title);
      formData.append("description", editedCourse.description);
      formData.append("category", editedCourse.category);
      formData.append("difficulty", editedCourse.difficulty);

      // Add new image if available
      if (newImage) {
        formData.append("image", newImage);
      }

      // Add new video if available
      if (newVideo) {
        formData.append(`video_${newVideo.moduleIndex}_${newVideo.lessonIndex}`, newVideo.file);
      }

      // Add modules and lessons data
      formData.append("modules", JSON.stringify(editedCourse.modules));

      // Make API call to update the course
      const response = await axios.put(`'${API_URL}/api/courses/${courseId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      message.success("Course updated successfully!");

      // Update the course state with the response data
      setCourse(response.data);
      setEditedCourse(JSON.parse(JSON.stringify(response.data)));
      setEditMode(false);
    } catch (error) {
      console.error("Error updating course:", error);
      if (error.response?.status === 413) {
        setMessage({ text: "File too large. Please reduce the size of your uploads", type: "error", visible: true });
      } else if (error.response?.data?.message) {

      } else {
        setMessage({ text: "Failed to update course", type: "error", visible: true });

      }
    } finally {
      setUploading(false);
    }

    setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);
  };

  const approveCourse = async (courseId) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/admin/approve-course/${courseId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`Failed to approve course. Status: ${response.status}`);
      }

      const result = await response.json();
      setLoading(false)
      setMessage({ text: "Course Approved Succesfully", type: "success", visible: true });
      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

      return result;
    } catch (error) {
      console.error("Error approving course:", error);
      setMessage({ text: "Course Approval Failed. Something went wrong", type: "error", visible: true });
      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

    } finally {
      setLoading(false); //stop loading regardless of outcome
      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

    }

    setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 3000);


  };

  // Calculate course stats
  const getTotalLessons = () => {
    if (!course || !course.modules) return 0;
    return course.modules.reduce(
      (sum, module) => sum + (module.lessons?.length || 0),
      0
    );
  };

  const getTotalDuration = () => {
    if (!course || !course.modules) return 0;
    let totalMinutes = 0;
    course.modules.forEach(module => {
      if (module.lessons) {
        module.lessons.forEach(lesson => {
          totalMinutes += lesson.lesson_duration || 0;
        });
      }
    });
    return totalMinutes;
  };

  const refreshEnrolledUsers = async () => {
    try {
      setEnrolledLoading(true);
      await enrolledRefetch();
    } catch (error) {
      setMessage({ text: "Failed to refresh enrolled users", type: "error", visible: true });
      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);
    } finally {
      setEnrolledLoading(false)
    }

  }

  const userManagementColumns = [
    {
      title: 'Enrollment ID',
      dataIndex: 'enrollment_id',
      key: 'enrollment_id',
      className: "table-cell",
      sorter: (a, b) => a.enrollment_id - b.enrollment_id,
    },
    {
      title: 'User ID',
      dataIndex: 'user_id',
      key: 'user_id',
      className: "table-cell",
      sorter: (a, b) => a.user_id - b.user_id,
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      className: "table-cell",
      sorter: (a, b) => a.first_name.localeCompare(b.first_name),
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      className: "table-cell",
      sorter: (a, b) => a.last_name.localeCompare(b.last_name),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      className: "table-cell",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Course Title',
      dataIndex: 'title',
      key: 'title',
      className: "table-cell",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Enrollment Date',
      dataIndex: 'enrollment_date',
      key: 'enrollment_date',
      className: "table-cell",
      sorter: (a, b) => new Date(a.enrollment_date) - new Date(b.enrollment_date),
      render: (text) => new Date(text).toLocaleDateString(),
    },
    // {
    //   title: 'Profile Picture',
    //   dataIndex: 'profile_pic',
    //   key: 'profile_pic',
    //   render: (url) =>
    //     url ? (
    //       <img
    //         src={allUsers.profile_pic}
    //         alt="Profile"
    //         style={{ width: 32, height: 32, borderRadius: '50%' }}
    //       />
    //     ) : (
    //       '-'
    //     ),
    // }
  ];

  const tabBarRef = useRef(null);

  const scrollTabs = (direction) => {
    const navWrap = tabBarRef.current?.querySelector(
      ".ant-tabs-nav-wrap"
    );

    if (navWrap) {
      navWrap.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth"
      });
    }
  };


  if (courseLoading) {
    return (
      <Loader />
    );
  }

  if (!course) {
    return (

      <Loader />
    );
  }

  const renderEditForm = () => (
    <Card>
      <Form layout="vertical" form={form} initialValues={editedCourse}>
        <Row gutter={[24, 16]}>
          <Col xs={24} md={8}>
            <Card title="Course Image" bordered={false}>
              <div style={{ textAlign: 'center' }}>
                <img
                  src={previewImage || (course.imageURL ? `${API_URL}${course.imageURL}` : "/default-course.jpg")}
                  alt={editedCourse.title}
                  style={{ maxWidth: '100%', marginBottom: '16px', borderRadius: '8px' }}
                  onError={(e) => {
                    console.error('Image load error:', e);
                    e.target.src = '/default-course.jpg';
                    message.warning('Could not load course image');
                  }}
                />
                <Upload
                  beforeUpload={() => false}
                  onChange={handleImageChange}
                  showUploadList={false}
                  accept="image/*"
                >
                  <Button icon={<UploadOutlined />} block>Change Image</Button>
                </Upload>
              </div>
            </Card>
          </Col>

          <Col xs={24} md={16}>
            <Form.Item
              label="Course Title"
              required
              tooltip="The main title of your course"
            >
              <Input
                value={editedCourse.title}
                onChange={(e) => updateCourseField('title', e.target.value)}
                placeholder="Enter a descriptive title for your course"
                size="large"
              />
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Category"
                  required
                  tooltip="The subject area of your course"
                >
                  <Input
                    value={editedCourse.category}
                    onChange={(e) => updateCourseField('category', e.target.value)}
                    placeholder="e.g. Web Development, Data Science"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Difficulty"
                  required
                  tooltip="The skill level required for this course"
                >
                  <Select
                    value={editedCourse.difficulty}
                    onChange={(value) => updateCourseField('difficulty', value)}
                    style={{ width: '100%' }}
                  >
                    <Option value="Beginner">Beginner</Option>
                    <Option value="Intermediate">Intermediate</Option>
                    <Option value="Advanced">Advanced</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Description"
              required
              tooltip="A detailed description of what students will learn"
            >
              <TextArea
                value={editedCourse.description}
                onChange={(e) => updateCourseField('description', e.target.value)}
                placeholder="Describe what students will learn in this course"
                rows={6}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );

  const renderCourseHeader = () => (
    <div style={{ marginBottom: '24px' }}>
      <Breadcrumb style={{ marginBottom: '16px' }}>
        <Breadcrumb.Item>
          <Link to="/admin-dashboard/courses">Courses</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {course.title}
        </Breadcrumb.Item>
      </Breadcrumb>

      <Row gutter={[24, 24]} align="middle">
        <Col xs={24} md={16}>
          <Title style={{ fontWeight: "500", color: "black" }} level={3}>{course.title}</Title>
          <Space size={[0, 8]} wrap style={{ marginBottom: '16px', gap: "10px" }}>
            <Tag style={{ color: "black" }} className="custom-tag" color="#ffa103">{course.category}
            </Tag>
            <Tag
              color="#039606"
              className="custom-tag"
            >
              {course.difficulty}
            </Tag>
            <Tag className="custom-tag" icon={<ClockCircleOutlined />}>
              {getTotalDuration()} minutes
            </Tag>
            <Tag className="custom-tag" icon={<BookOutlined />}>
              {getTotalLessons()} {`${getTotalLessons() > 1 ? 'Lessons' : 'Lesson'}`}
            </Tag>

            <Tag
              className="custom-tag"
              style={{
                backgroundColor: '#fff',
                color: course.published ? '#039606' : '#575a5e',
                border: course.published ? '1px solid #039606' : '1px solid #575a5e'
              }}
            >
              {course.published ? 'Published' : 'Unpublished'}
            </Tag>



          </Space>
        </Col>

        <Col xs={24} md={8} style={{ textAlign: 'right' }}>
          <Space>
            {editMode ? (
              <>
                <Button
                  onClick={toggleEditMode}
                  icon={<CloseOutlined />}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  onClick={handleSaveChanges}
                  loading={uploading}
                  icon={<SaveOutlined />}
                >
                  Save Changes
                </Button>
              </>
            ) : (
              <>
                {/* <Button
                  className="approve-btn"
                  onClick={toggleEditMode}
                  icon={<EditOutlined />}
                >
                  Edit Course
                </Button> */}
                <Button
                  className={course.published ? "reject-btn-nofill" : "approve-btn"}
                  onClick={() => handlePublishToggle(courseId, cloudId)}
                  loading={publishing}
                >
                  {publishing ? null : (
                    <>
                      {course.published ? <StopOutlined /> : <CheckCircleOutlined />}
                      {course.published ? ' Unpublish' : ' Publish'}
                    </>
                  )}
                </Button>
              </>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );

  const renderVideoModal = () => (
    <Modal
      title="Video Lesson"
      open={isVideoModalVisible}
      onCancel={handleVideoClose}
      footer={null}
      width="80%"
    >
      {selectedVideo && (
        <video
          ref={videoRef}
          src={selectedVideo}
          controls
          style={{ width: '100%', maxHeight: '70vh' }}
          autoPlay
        />
      )}
    </Modal>
  );

  return (
    <main>
      {/* alert */}
      {message.text && (
        <div className={`toast-alert ${message.visible ? "toast-show" : ""} ${message.type === "success" ? "toast-success" : "toast-error"}`} role="alert">
          {message.text}
        </div>
      )}
      {isError404 ? <Empty description="This course has been removed" /> :

        loading ? <Loader /> : <div className="view-course-container" >

          {/* date selector */}
          <Modal
            centered
            title={<div style={{ fontSize: 'large' }} className="d-flex justify-content-center">Select Export Date Range</div>}
            open={filterModalVisible}
            onCancel={() => {
              setFilterModalVisible(false);
            }}
            footer={null}

          >
            <div className="d-flex flex-column gap-4 mb02">
              <Space className="mt-2" vertical>
                <DatePicker placeholder="Select Start Date" value={startDate} onChange={(date) => setStartDate(date)} />
                <DatePicker placeholder="Select End Date" value={endDate} onChange={(date) => setEndDate(date)} />
              </Space>

              <button className="btn primary-btn" onClick={exportEnrollments} disabled={isExportLoading}>
                {isExportLoading ? <ImSpinner2 className="btn-spinner" /> : 'Export to CSV'}
              </button>
            </div>
          </Modal>


          {/* Video/PDF Modal */}
          <Modal
            centered
            title={isPDF ? "PDF Lesson" : "Video Lesson"}
            open={isVideoModalVisible}
            onCancel={handleVideoClose}
            footer={null}
            width="80%"
          >
            {selectedVideo && (
              <div className="mt-4">
                {isPDF ? (
                  <iframe
                    src={selectedVideo}
                    style={{ width: '100%', height: '80vh', border: 'none' }}
                    title="PDF Preview"
                  />
                ) : (
                  <video
                    className="mt-4"
                    ref={videoRef}
                    src={selectedVideo}
                    controls
                    style={{ width: '100%', maxHeight: '70vh' }}
                    autoPlay
                    onError={(e) => {
                      console.error('Video error:', e);
                      setMessage({ text: "Error loading video: The video file may be missing or in an unsupported format", type: "error", visible: true });
                      setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

                    }}
                  />
                )}
              </div>
            )}
          </Modal>

          {/* course enrollments modal */}
          <Modal
            centered

            title={

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontWeight: '600',
                fontSize: '18px',
                justifyContent: "center"

              }}>
                {course.title}
              </div>
            }
            open={showEnrolledModal}
            onCancel={handleEnrollModalClose}
            footer={null}
            width="100%"

          >
            <div className="search-refresh-container d-flex align-items-center flex-wrap mt-4">

              {/* Left section: Search + Refresh */}
              <div className="d-flex align-items-center flex-wrap gap-3">

                {/* Search Bar */}
                <form className="col-12 col-md-auto" role="search">
                  <div className="search-container position-relative">
                    <img
                      loading="lazy"
                      src="/images/search-icn.png"
                      alt="Search Icon"
                      className="search-icn"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "18px",
                        height: "18px"
                      }}
                    />

                    <input
                      type="search"
                      className="form-control course-search rounded w-100"
                      placeholder="Search learners..."
                      aria-label="Search"
                      style={{ paddingLeft: "40px" }}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </form>

                {/* Refresh Button */}
                <button
                  onClick={refreshEnrolledUsers}
                  className="btn refresh-btn d-flex align-items-center justify-content-center gap-2"
                >
                  {enrolledLoading ? (
                    <ImSpinner2 className="button-spinner-plain" />
                  ) : (
                    <>
                      Refresh List <IoIosRefresh />
                    </>
                  )}
                </button>

              </div>

              {/* Export button on far right */}
              <div className="ms-auto mt-3 mt-md-0">
                <button
                  onClick={() => setFilterModalVisible(true)}
                  className="btn secondary-btn d-flex align-items-center justify-content-center gap-2"
                >
                  {isExportLoading ? (
                    <ImSpinner2 className="button-spinner-plain" />
                  ) : (
                    <>Export Enrollments</>
                  )}
                </button>
              </div>

            </div>


            {isEnrolledDataLoading ?
              <div className="users-spinner-container">
                <ImSpinner2 className="users-spinner" />
              </div>
              :
              isMobile ? (
                <>
                  {/* Sorting Controls */}
                  <Row gutter={12} style={{ marginBottom: '1rem' }}>
                    <Col span={12}>
                      <Select
                        value={userSortField}
                        onChange={handleUserSortFieldChange}
                        style={{ width: '100%', borderColor: "#ffa103" }}
                      >
                        <Option value="user_id">User ID</Option>
                        <Option value="enrollment_id">Enrollment ID</Option>

                        <Option value="first_name">First Name</Option>
                        <Option value="last_name">Last Name</Option>
                        <Option value="email">Email</Option>
                        <Option value="enrollment_date">Enrollment Date</Option>
                      </Select>
                    </Col>
                    <Col span={12}>
                      <Select
                        value={userSortOrder}
                        onChange={handleUserSortOrderChange}
                        style={{ width: '100%', borderColor: "#ffa103" }}

                      >
                        <Option value="asc">Ascending</Option>
                        <Option value="desc">Descending</Option>
                      </Select>
                    </Col>
                  </Row>

                  {/* Card view */}
                  {sortedUsers.map((user) => (
                    <Card
                      key={user.user_id}
                      className="mb-3 shadow-sm "

                      title={
                        <div className="d-flex justify-content-between align-items-center">
                          <span>{user.first_name} {user.last_name}</span>
                          <span className="badge">Enrolled</span>
                        </div>
                      }
                    >
                      <p><strong>Enrollment ID:</strong> {user.enrollment_id}</p>
                      <p><strong>User ID:</strong> {user.user_id}</p>
                      <p><strong>First Name:</strong> {user.first_name}</p>
                      <p><strong>Last Name:</strong> {user.last_name}</p>
                      <p><strong>Email:</strong> {user.email}</p>

                      <p><strong>Course Title:</strong> {user.title}</p>
                      <p><strong>Enrollment_date:</strong> {new Date(user.enrollment_date).toLocaleDateString()}</p>
                    </Card>
                  ))}
                </>
              ) : (
                <Table
                  rowKey="user_id"
                  dataSource={enrolledUsers}
                  columns={userManagementColumns}
                  pagination={false}
                  className="table-header mt-3"
                />
              )
            }

            <Pagination
              simple
              current={page}
              pageSize={limit}
              total={totalPages}
              onChange={paginateUsers}
              style={{
                display: 'inline-block',
                padding: '12px 12px 12px',
                borderRadius: '8px',
                backgroundColor: '#f0f2f5',
                boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
                fontWeight: 500,
                marginTop: "12px"
              }}
              itemRender={(page, type, originalElement) => {
                if (type === 'prev') {
                  return <span style={{ color: '#ffa103' }}><CiCircleChevLeft size={27} /></span>;
                }
                if (type === 'next') {
                  return <span style={{ color: '#ffa103' }}><CiCircleChevRight size={27} /></span>;
                }
                return <span style={{ color: '#000' }}>{page}</span>;
              }}
            />

          </Modal>


          {/* Publish/Unpublish Course Modal */}
          <Modal
            centered
            title={course.published ? "Confirm Unpublish" : "Confirm Publish"}
            open={showPublishModal}
            onCancel={() => setShowPublishModal(false)}
            okText={course.published ? "Unpublish" : "Publish"}
            cancelText="Cancel"
            footer={[
              <Button
                key="cancel"
                onClick={() => setShowPublishModal(false)}
                className="custom-cancel-btn"
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className={course.published ? "custom-danger-btn" : "approve-btn"}
                onClick={confirmPublish}
              >
                {course.published ? "Unpublish" : "Publish"}
              </Button>
            ]}
          >
            {course.published ? (
              <div>
                <p>
                  Are you sure you want to <strong>unpublish "{course.title}"</strong>?
                </p>
                <p>
                  Students who are not already enrolled will no longer be able to view or
                  enrol in this course. Existing enrolled students will retain access.
                </p>
              </div>
            ) : (
              <div>
                <p>
                  Are you sure you want to <strong>publish "{course.title}"</strong>?
                </p>
                <p>
                  Once published, this course will become visible in the course catalogue
                  and will be available for learners to enrol.
                </p>
              </div>
            )}
          </Modal>


          {/* Resource Modal */}
          <Modal
            centered
            title={selectedResource?.title || "Resource Preview"}
            open={isResourceModalVisible}
            onCancel={handleResourceClose}
            footer={null}
            width="80%"
          >
            {selectedResource && (
              <div style={{ padding: '20px' }}>
                <Typography.Title level={4}>{selectedResource.title}</Typography.Title>
                <Typography.Text type="secondary">
                  {selectedResource.description}
                </Typography.Text>
                <Card style={{ marginTop: '16px' }}>
                  {selectedResource.type === 'pdf' && (
                    <iframe
                      src={selectedResource.url}
                      style={{ width: '100%', height: '600px', border: 'none' }}
                    />
                  )}
                  {selectedResource.type === 'link' && (
                    <a href={selectedResource.url} target="_blank" rel="noopener noreferrer">
                      {selectedResource.url}
                    </a>
                  )}
                </Card>
              </div>
            )}
          </Modal>

          <div className="view-course-content" style={{ maxWidth: '', margin: '0 auto' }}>
            {renderCourseHeader()}

            {editMode ? (
              <div>
                {renderEditForm()}

                <Card style={{ marginTop: '24px' }}>
                  <Title level={4}>Course Modules</Title>
                  <Collapse defaultActiveKey={["0"]} collapsible="disabled">
                    {editedCourse.modules?.map((module, moduleIndex) => (
                      <Panel
                        header={
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Space>
                              <span className="module-title">
                                {module.module_name || `Module ${moduleIndex + 1}`}
                              </span>
                            </Space>
                            <Button
                              type="link"
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditingModule(editingModule === moduleIndex ? null : moduleIndex);
                              }}
                            >
                              {editingModule === moduleIndex ? "Done" : "Edit"}
                            </Button>
                          </div>
                        }
                        key={moduleIndex}
                      >
                        {editingModule === moduleIndex && (
                          <Form layout="vertical" style={{ marginBottom: '20px' }}>
                            <Form.Item label="Module Name" required>
                              <Input
                                value={module.module_name}
                                onChange={(e) => updateModuleField(moduleIndex, 'module_name', e.target.value)}
                                placeholder="Module Name"
                              />
                            </Form.Item>

                            <Form.Item label="Module Description">
                              <TextArea
                                value={module.module_description}
                                onChange={(e) => updateModuleField(moduleIndex, 'module_description', e.target.value)}
                                placeholder="Module Description"
                                rows={3}
                              />
                            </Form.Item>
                          </Form>
                        )}

                        <List
                          itemLayout="horizontal"
                          dataSource={module.lessons || []}
                          renderItem={(lesson, lessonIndex) => (
                            <List.Item
                              actions={[
                                <Button
                                  key="edit"
                                  type="link"
                                  onClick={() => setEditingLesson(lessonIndex === editingLesson ? null : lessonIndex)}
                                >
                                  {lessonIndex === editingLesson ? "Done" : "Edit"}
                                </Button>
                              ]}
                            >
                              <List.Item.Meta
                                avatar={
                                  <Avatar
                                    icon={<VideoCameraOutlined />}
                                    style={{
                                      backgroundColor: "#1890ff"
                                    }}
                                  />
                                }
                                title={
                                  editingLesson === lessonIndex ? (
                                    <Input
                                      value={editedCourse.modules[moduleIndex].lessons[lessonIndex].title}
                                      onChange={(e) => updateLessonField(moduleIndex, lessonIndex, 'title', e.target.value)}
                                      placeholder="Lesson Title"
                                    />
                                  ) : (
                                    lesson.title
                                  )
                                }
                                description={
                                  editingLesson === lessonIndex ? (
                                    <div>
                                      <TextArea
                                        value={editedCourse.modules[moduleIndex].lessons[lessonIndex].description}
                                        onChange={(e) => updateLessonField(moduleIndex, lessonIndex, 'description', e.target.value)}
                                        placeholder="Lesson Description"
                                        rows={2}
                                        style={{ marginBottom: '16px' }}
                                      />

                                      <div style={{ marginTop: '16px' }}>
                                        <Title level={5}>Lesson Video</Title>
                                        <Upload
                                          accept="video/*"
                                          beforeUpload={() => false}
                                          onChange={(info) => handleVideoChange(info, moduleIndex, lessonIndex)}
                                          showUploadList={false}
                                        >
                                          <Button icon={<UploadOutlined />}>
                                            Change Video (Max 100MB)
                                          </Button>
                                        </Upload>

                                        {previewVideo &&
                                          previewVideo.moduleIndex === moduleIndex &&
                                          previewVideo.lessonIndex === lessonIndex ? (
                                          <div style={{ marginTop: '16px' }}>
                                            <video
                                              ref={videoRef}
                                              controls
                                              src={previewVideo.url}
                                              style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            />
                                            <p>New video: {newVideo?.file?.name}</p>
                                            <p>Duration: {editedCourse.modules[moduleIndex].lessons[lessonIndex].lesson_duration} minutes</p>
                                          </div>
                                        ) : lesson.videoURL ? (
                                          <div style={{ marginTop: '16px' }}>
                                            <video
                                              controls
                                              src={lesson.videoURL}
                                              style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            />
                                            <p>Current video</p>
                                            <p>Duration: {lesson.lesson_duration} minutes</p>
                                          </div>
                                        ) : (
                                          <Alert
                                            message="No video available"
                                            type="warning"
                                            style={{ marginTop: '16px' }}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <Space>
                                      {lesson.description && (
                                        <Text type="secondary">{lesson.description}</Text>
                                      )}
                                      {lesson.lesson_duration && (
                                        <Tag icon={<ClockCircleOutlined />}>
                                          {lesson.lesson_duration} min
                                        </Tag>
                                      )}
                                    </Space>
                                  )
                                }
                              />
                            </List.Item>
                          )}
                        />
                      </Panel>
                    ))}
                  </Collapse>
                </Card>
              </div>
            ) : (
              <Row gutter={[24, 24]}>
                <Col xs={24} md={8}>


                  <Card
                    cover={
                      <img
                        alt={course.title}
                        src={course.imageURL || "/default-course.jpg"}
                        style={{
                          width: "100%",
                          maxHeight: '200px',
                          objectFit: 'cover'
                        }}
                      />
                    }
                    style={{
                      marginBottom: '24px',
                      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                    }}
                  >
                    <Card.Meta
                      title={
                        <Space>

                          <div className="d-flex flex-column" style={{ alignItems: "flex-start", gap: "8px" }}>
                            <span style={{ fontSize: "17px" }}>
                              <UserOutlined style={{ marginRight: "6px" }} />
                              <span style={{ color: '#039606', fontWeight: 600 }}>Instructor:</span>{' '}
                              <span style={{ color: "#333" }}>{course.author || 'Unknown'}</span>
                            </span>

                            <span style={{ fontSize: "17px" }}>
                              <IoPricetagOutline style={{ marginRight: "6px" }} />
                              <span style={{ color: '#039606', fontWeight: 600 }}>Price:</span>{' '}
                              <span style={{ color: "#333" }}>K{course.price}</span>
                            </span>
                          </div>

                        </Space>
                      }
                    />
                  </Card>

                  <Card style={{
                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
                  }} title={<span style={{ fontSize: "medium", fontWeight: 600 }}>Course Summary</span>}>
                    <List>
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              icon={<BookOutlined style={{ fontSize: '20px' }} />}
                              size={48}
                              style={{
                                backgroundColor: '#ffa103',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            />
                          }
                          title={<span style={{ fontSize: 'medium', fontWeight: 600 }}>Total Modules</span>}
                          description={
                            <span style={{ fontSize: '15px' }}>
                              {course.modules?.length || 0} {`${course.modules?.length > 1 ? 'Modules' : 'Module'}`}
                            </span>
                          }
                        />
                      </List.Item>

                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              icon={<FileTextOutlined style={{ fontSize: '20px' }} />}
                              size={48}
                              style={{
                                backgroundColor: '#ffa103',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            />
                          }
                          title={<span style={{ fontSize: 'medium', fontWeight: 600 }}>Total Lessons</span>}
                          description={
                            <span style={{ fontSize: '15px' }}>
                              {getTotalLessons()} {`${getTotalLessons() > 1 ? 'Lessons' : 'Lesson'}`}
                            </span>
                          }
                        />
                      </List.Item>

                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              icon={<ClockCircleOutlined style={{ fontSize: '20px' }} />}
                              size={48}
                              style={{
                                backgroundColor: '#ffa103',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            />
                          }
                          title={<span style={{ fontSize: 'medium', fontWeight: "600" }}>Total Duration</span>}
                          description={<span style={{ fontSize: '15px' }}>{getTotalDuration()} minutes</span>}
                        />
                      </List.Item>


                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              icon={<SlBookOpen style={{ fontSize: '20px' }} />}
                              size={48}
                              style={{
                                backgroundColor: '#ffa103',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            />
                          }
                          title={<span style={{ fontSize: 'medium', fontWeight: "600" }}>Enrollments</span>}
                          description={<a onClick={() => setShowEnrolledModal(true)} style={{ fontSize: '15px' }} className="btn-link">View Course Enrollments</a>}
                        />
                      </List.Item>
                    </List>







                  </Card>
                </Col>

                <Col xs={24} md={16}>
                  <Card style={{
                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                  }}>
                    <div style={{ position: "relative" }}>
                      {/* Left button */}
                      <Button
                        shape="circle"
                        icon={<LeftOutlined />}
                        onClick={() => scrollTabs("left")}
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 8,
                          zIndex: 10
                        }}
                        className="mobile-tab-nav"
                      />

                      {/* Right button */}
                      <Button
                        shape="circle"
                        icon={<RightOutlined color='#039606' />}
                        onClick={() => scrollTabs("right")}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 8,
                          zIndex: 10
                        }}
                        className="mobile-tab-nav"
                      />

                      <Tabs
                        defaultActiveKey="content"
                        className="custom-tabs"
                        renderTabBar={(props, DefaultTabBar) => (
                          <div
                            ref={tabBarRef}
                            style={{
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              padding: "0 45px",
                              scrollbarWidth: "none"
                            }}
                          >
                            <DefaultTabBar {...props} />
                          </div>
                        )}
                      >
                        <TabPane
                          tab={
                            <span className="d-flex align-items-center">
                              <BarsOutlined />
                              <span>Course Content</span>
                            </span>
                          }
                          key="content"
                        >
                          <div className="pt-3" style={{ marginBottom: '16px' }}>
                            <Title style={{ color: "#039606" }} level={4}>Curriculum</Title>
                            {/* <Paragraph style={{ fontSize: "large" }}>{course.description}</Paragraph> */}
                          </div>

                          <Divider style={{ fontSize: "medium", color: "#333" }} orientation="left">Course Modules</Divider>

                          <Collapse
                            defaultActiveKey={["1"]}
                            expandIconPosition="end"
                            expandIcon={({ isActive }) => (
                              <IoIosArrowDropdown
                                style={{
                                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                                  transition: "transform 0.2s",
                                  fontSize: "20px",
                                  color: "#039606",
                                  display: "flex",
                                  alignItems: "center"
                                }}
                              />
                            )}
                            className="custom-collapse"
                          >
                            {course.modules?.map((module, moduleIndex) => (
                              <Panel
                                key={moduleIndex}
                                header={
                                  <div
                                    className="collapse-header-content"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%"
                                    }}
                                  >
                                    <div style={{ flex: 1 }}>
                                      <Text style={{ fontSize: "medium", color: "#333", fontWeight: "500" }}>
                                        {module.module_name || `Module ${moduleIndex + 1}`}
                                      </Text>
                                      {isModuleCompleted(module.module_id) && (
                                        <Tag
                                          color="success"
                                          icon={<CheckCircleOutlined />}
                                          style={{ marginLeft: 10 }}
                                        >
                                          Completed
                                        </Tag>
                                      )}
                                    </div>

                                    <Space style={{ marginRight: 16 }}>
                                      <Text type="secondary">
                                        {module.lessons?.length} {`${module.lessons?.length > 1 ? 'Lessons' : 'Lesson'}`}

                                      </Text>
                                    </Space>
                                  </div>
                                }
                              >

                                <List
                                  itemLayout="horizontal"
                                  dataSource={module.lessons || []}
                                  renderItem={(lesson, lessonIndex) => (
                                    <List.Item
                                      style={{
                                        backgroundColor: isLessonCompleted(lesson.lesson_id)
                                          ? 'rgba(82, 196, 26, 0.1)'
                                          : 'transparent',
                                        transition: 'background-color 0.3s ease'
                                      }}
                                      actions={[
                                        (lesson.lesson_video || lesson.content) && (
                                          <Tooltip
                                            title='View Lesson'
                                          >
                                            <Button
                                              type="link"
                                              icon={
                                                isLessonCompleted(lesson.lesson_id)
                                                  ? <CheckCircleFilled style={{ color: '#ffa103' }} />
                                                  : <PlayCircleOutlined style={{ color: '#ffa103', fontSize: "large" }} />
                                              }
                                              onClick={() => handleViewLesson(lesson)}
                                            />
                                          </Tooltip>
                                        ),
                                        lesson.resources && lesson.resources.length > 0 && (
                                          <Tooltip title="Additional Resources">
                                            <Button
                                              type="link"
                                              icon={<FileOutlined />}
                                              onClick={() => handleResourcePreview(lesson.resources[0])}
                                            />
                                          </Tooltip>
                                        )
                                      ]}
                                    >
                                      <List.Item.Meta
                                        avatar={
                                          <Avatar
                                            icon={<VideoCameraOutlined />}
                                            style={{
                                              // backgroundColor: isLessonCompleted(lesson.lesson_id)
                                              //   ? "#52c41a"
                                              //   : "#1890ff",
                                              backgroundColor: "#ffa103",
                                              color: "#000",
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              opacity: isLessonCompleted(lesson.lesson_id) ? 0.6 : 1
                                            }}
                                          />
                                        }
                                        title={
                                          <div style={{
                                            textDecoration: isLessonCompleted(lesson.lesson_id)
                                              ? 'line-through'
                                              : 'none',
                                            color: isLessonCompleted(lesson.lesson_id)
                                              ? '#999'
                                              : 'inherit',

                                            fontSize: "medium",
                                            fontWeight: "400"

                                          }}>
                                            {lesson.title}
                                          </div>
                                        }
                                        description={
                                          <Space>



                                            {lesson.lesson_duration ? (
                                              <Tag
                                                icon={<ClockCircleOutlined style={{ fontSize: '16px' }} />}
                                                style={{
                                                  fontSize: '16px',
                                                  padding: '4px 10px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                {lesson.lesson_duration} min
                                              </Tag>
                                            ) : (<Tag
                                              icon={<FaRegFilePdf style={{ fontSize: '16px' }} />}
                                              style={{
                                                fontSize: '16px',
                                                padding: '4px 10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px'

                                              }}
                                            >
                                              PDF
                                            </Tag>)}
                                          </Space>
                                        }
                                      />
                                    </List.Item>
                                  )}
                                />
                              </Panel>
                            ))}
                          </Collapse>
                        </TabPane>

                        {/* Learning Outcomes Tab */}
                        <TabPane
                          tab={
                            <span className="d-flex align-items-center">
                              <InfoCircleOutlined />
                              <span>Learning Outcomes</span>
                            </span>
                          }
                          key="outcomes"
                        >
                          {!course.learningOutcomes || Object.keys(course.learningOutcomes).length === 0 ? (
                            <Empty description="No learning outcomes available" />
                          ) : (
                            <List
                              itemLayout="horizontal"
                              dataSource={Object.values(course.learningOutcomes)}
                              renderItem={(content, index) => (
                                <List.Item>
                                  <List.Item.Meta
                                    avatar={
                                      <Avatar style={{ backgroundColor: '#039606' }}>
                                        {index + 1}
                                      </Avatar>
                                    }
                                    title={
                                      <span style={{ fontSize: 'medium', fontWeight: '400' }}>
                                        {content.content}
                                      </span>
                                    }
                                  />
                                </List.Item>
                              )}
                            />
                          )}
                        </TabPane>

                        {/* Exam Tab */}
                        <TabPane
                          tab={
                            <span className="d-flex align-items-center">
                              <FileTextOutlined />
                              <span>Exams</span>
                            </span>
                          }
                          key="exams"
                        >
                          {Array.isArray(exams) && exams.length === 0 ? (
                            <Empty description="No exam available" />
                          ) : (
                            <div>
                              {exams.map((exam, examIndex) => (
                                <Card key={exam.exam_id} style={{ marginBottom: 16 }}>
                                  <Card.Meta
                                    title={
                                      <div className="d-flex flex-column">
                                        <p style={{ color: "#333", marginBottom: "4px", fontWeight: 500 }}>
                                          <span style={{ color: "#039606" }}>Exam Title: </span>
                                          {exam.exam_title}
                                        </p>
                                        <p style={{ marginTop: "2px", fontWeight: 400 }}>
                                          <span style={{ color: "#039606" }}>Exam Description: </span>
                                          {exam.exam_description}
                                        </p>
                                      </div>
                                    }
                                  />

                                  {examQuestions && examQuestions.length > 0 ? (
                                    <Collapse
                                      defaultActiveKey={["1"]}
                                      expandIconPosition="end"
                                      expandIcon={({ isActive }) => (
                                        <IoIosArrowDropdown
                                          style={{
                                            transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "transform 0.2s",
                                            fontSize: "20px",
                                            color: "#039606",
                                            display: "flex",
                                            alignItems: "center"
                                          }}
                                        />
                                      )}
                                      className="custom-collapse mt-3"
                                    >
                                      {examQuestions.map((question, idx) => (
                                        <Panel
                                          key={question.question_id}
                                          header={
                                            <div
                                              className="collapse-header-content"
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%"
                                              }}
                                            >
                                              <div style={{ flex: 1 }}>
                                                <Text style={{ fontSize: "medium", color: "#333", fontWeight: "500" }}>
                                                  Question {idx + 1}: {question.question_text}
                                                </Text>
                                              </div>

                                            </div>
                                          }
                                        >
                                          {question.question_diagram && (
                                            <img
                                              src={question.question_diagram}
                                              alt="diagram"
                                              loading="lazy"
                                              style={{ maxWidth: "100%", marginBottom: 16, height: "200px" }}
                                            />
                                          )}

                                          <List
                                            dataSource={question.options}
                                            renderItem={opt => (
                                              <List.Item
                                                style={{
                                                  fontSize: "medium",
                                                  color: opt.is_correct === true ? "#039606" : "inherit"
                                                }}
                                              >
                                                {opt.option_text}
                                              </List.Item>
                                            )}
                                            size="small"
                                          />
                                        </Panel>
                                      ))}
                                    </Collapse>
                                  ) : (
                                    <Text className="text-secondary">No questions available.</Text>
                                  )}
                                </Card>
                              ))}
                            </div>
                          )}
                        </TabPane>
                      </Tabs>
                    </div>
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        </div>
      }

    </main>

  );
};

export default ViewCourseDetails;